export const labels = {
  // Panel Headers
  dummyLocalizationText: "ar-ms Dummy Localization Text",
  unexpectedApiFailure: "ar-ms Unexpected API failure. Please try again.",
  canvasDataEditor: "ar-ms Canvas data editor",
  selectanitemtoedit: "ar-ms Select an item to edit:",
  sheetWithSameNameExist: "ar-ms A sheet named Input_sheet_{0} already exists. Please rename the sheet to continue.",
  engagementIdNotFound: "ar-ms Could not find the EY Canvas engagement. Check the Engagement ID and confirm you have access to open the EY Canvas engagement.",
  boundSheetAlreadyExist: "ar-ms EY Canvas Bulk Update Add-in does not work on this tab",
  masterSheetNoteText: "ar-ms Note: This sheet is required to use EY Canvas Bulk Update Add-in.",
  informationText: "ar-ms This tool allows you to edit EY Canvas document and task names for Standardized Indexing using Excel.",
  yes: "ar-ms Yes",
  no: "ar-ms No",
  close: "ar-ms Close",
  ownedByEngagement: "ar-ms Owned by this engagement",
  sharedToEngagement: "ar-ms Shared into this engagement",
  status: "ar-ms Status",
  statusId: "ar-ms Status id",
  updateCanvas: "Update EY Canvas",
  newDocumentName: "ar-ms New document name",
  documentName: "ar-ms Document name",
  fileExt: "ar-ms File extension",
  shared: "ar-ms Shared",
  docId: "ar-ms Document Id",
  hash: "ar-ms Hash",
  newPrefix: "ar-ms New prefix",
  newSuffix: "ar-ms New suffix",
  newTitle: "ar-ms New title",
  taskPrefix: "ar-ms Task prefix",
  taskSuffix: "ar-ms Task suffix",
  taskTitle: "ar-ms Task title",
  taskType: "ar-ms Task type",
  taskTitleEditable: "ar-ms Task title editable",
  auditPhase: "ar-ms Audit Phase",
  milestone: "ar-ms Milestone",
  timePhase: "ar-ms Time Phase",
  taskId: "ar-ms Task Id",
};

export const errors = {
  14057: "ar-ms A document with the same name already exists in the engagement.",
  14084: 'ar-ms File name cannot include: */:<>?|""',
  14085: "ar-ms The document name exceeded maximum length allowed.",
  14086: "ar-ms DocService failed while updating document details.",
};

export const milestonesLabels = {
  1: 'ar-ms Scope',
  2: 'ar-ms Strategy',
  3: 'ar-ms Walkthroughs',
  4: 'ar-ms Interim control testing',
  5: 'ar-ms Interim substantive testing',
  6: 'ar-ms Walkthroughs (year-end processes)',
  7: 'ar-ms Year-end control testing',
  8: 'ar-ms Year-end substantive testing',
  9: 'ar-ms Conclusion',
  10: 'ar-ms Not applicable',
  11: 'ar-ms Execution',
  12: 'ar-ms Group audit S&S',
  13: 'ar-ms Preliminary planning',
  14: 'ar-ms CRA',
  15: 'ar-ms Identify and assess risk',
  16: 'ar-ms Design response to risk',
  17: 'ar-ms Post-interim project management'
};

export const filterAuditPhases = {
  1: 'ar-ms Scope & strategy',
  2: 'ar-ms Execution',
  3: 'ar-ms Conclusion'
};

export const uploadStatusLabels = {
  1: "ar-ms Pending Sync", //pending
  2: "ar-ms Offline Edited", //offlineEdit
  3: "ar-ms Downloaded", //downloaded
  4: "ar-ms Uploaded", //uploaded
  5: "ar-ms Invalid Input", //invalidInput
  6: "ar-ms Server Error", //serverError
  7: "ar-ms Unexpected API Error", //unexpectedAPIError
  8: "ar-ms Client Fetch Error" //clientFetchError
}